// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__28KIX","right":"styles_right__8PePD"};